import { Button, Tooltip } from "antd"
import { FileExcelOutlined } from "@ant-design/icons"

const ExcelButton = ({ onClick, size = 'small', type = 'primary', tooltip = 'Descargar Excel', style = {}, loading = false, rest }) => {
  return (
    <Tooltip title={tooltip}>
      <Button
        size={size}
        type={type}
        style={{ backgroundColor: '#1D6F42', borderColor: '#1D6F42', ...style }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2fb36a', e.currentTarget.style.borderColor = '#2fb36a')}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#1D6F42', e.currentTarget.style.borderColor = '#1D6F42')}
        icon={<FileExcelOutlined />}
        onClick={onClick}
        loading={loading}
        {...rest}
      />
    </Tooltip>
  )
};

export default ExcelButton;